import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentinpune() {



const cardData = {
  keyword: "Mini Bus On Rent in Pune",
  heading: "Lotus Cab: Mini Bus On Rent in Pune",

  headingDescription:
    "Lotus Cab offers reliable and affordable Mini Bus On Rent in Pune services for group travel, corporate outings, school trips, weddings, and outstation tours. Our fleet includes 18, 20, and 25 seater mini buses designed for comfortable and safe group transportation. All vehicles are well-maintained, air-conditioned, and driven by professional, background-verified drivers with excellent highway and city route experience. Whether you are planning a family function, corporate event, picnic, or long-distance travel, our mini bus rental ensures spacious seating and luggage support. We provide transparent per-kilometer pricing with flexible one-way, round-trip, and multi-day packages. With doorstep pickup anywhere in Pune and easy online booking support, Lotus Cab makes group travel simple, comfortable, and stress-free.",

  top: "Top Places to Visit in Pune with Mini Bus Rental",

  topPlaces: [
    {
      title: "Shaniwar Wada",
      description:
        "Shaniwar Wada is Pune’s most iconic historical landmark and a popular destination for group sightseeing tours. Mini bus rental is ideal for school trips and large family visits to this heritage fort. Spacious seating ensures comfortable travel for everyone in the group. AC comfort makes the journey pleasant even during summer. Lotus Cab provides flexible waiting time for exploring nearby markets and attractions."
    },
    {
      title: "Aga Khan Palace",
      description:
        "Aga Khan Palace is a significant historical monument connected to India’s freedom movement. School groups and corporate teams often visit for educational tours. Our mini bus provides safe and organized group travel with professional drivers. Comfortable seating ensures a relaxed journey."
    },
    {
      title: "Sinhagad Fort",
      description:
        "Sinhagad Fort is a popular trekking and picnic destination near Pune. Mini bus rental is perfect for transporting large groups safely to the base point. The vehicle offers stable performance on ghat roads. Lotus Cab ensures experienced drivers for safe uphill travel."
    },
    {
      title: "Khadakwasla Dam",
      description:
        "Khadakwasla Dam is a scenic picnic location ideal for family and office outings. A mini bus allows the entire group to travel together conveniently. AC comfort and luggage space enhance the experience."
    },
    {
      title: "Lavasa",
      description:
        "Lavasa is a picturesque hill destination near Pune suitable for weekend group trips. Mini bus rental ensures comfortable seating and smooth highway travel for larger groups."
    },
    {
      title: "Lonavala",
      description:
        "Lonavala is a famous hill station frequently visited by families, schools, and corporate groups. Our mini bus provides safe and spacious travel via the expressway."
    },
    {
      title: "Mahabaleshwar",
      description:
        "Mahabaleshwar is a popular hill station for group tours and school excursions. Mini bus rental ensures comfortable long-distance travel with luggage support."
    },
    {
      title: "Shirdi",
      description:
        "Shirdi is a major pilgrimage destination. Group darshan trips are convenient with mini bus rental ensuring smooth round-trip travel."
    },
    {
      title: "Imagicaa",
      description:
        "Imagicaa theme park is ideal for corporate and school outings. Mini bus ensures safe and coordinated group transportation."
    },
    {
      title: "Pune Airport",
      description:
        "Mini bus airport transfers are ideal for large family pickups and corporate staff transportation with adequate luggage space."
    }
  ],

  services: [
    {
      name: "Mini Bus On Rent in Pune",
      description:
        "Book Mini Bus on Rent in Pune with Lotus Cab for safe and comfortable group travel. Our mini buses are available in 18, 20, and 25 seater configurations, ideal for family functions, school trips, and corporate outings. Each vehicle is equipped with air-conditioning, pushback seating, ample legroom, and luggage space. Professional drivers ensure safe city and highway driving. Transparent per-km pricing with flexible booking options available."
    },
    {
      name: "18 Seater Mini Bus Pune",
      description:
        "18 seater mini bus rental in Pune is perfect for small group tours and family gatherings. Comfortable seating and AC interiors provide relaxed travel. Suitable for city tours and short outstation trips."
    },
    {
      name: "20 Seater Mini Bus Pune",
      description:
        "20 seater mini bus rental offers balanced space and comfort for medium-sized groups. Ideal for office outings and picnic trips. Professional driver included."
    },
    {
      name: "25 Seater Mini Bus Pune",
      description:
        "25 seater mini bus is ideal for school trips and large group tours. Spacious seating and luggage capacity ensure comfortable travel."
    },
    {
      name: "AC Mini Bus Rental Pune",
      description:
        "Fully air-conditioned mini bus rental ensuring comfortable travel during all seasons. Ideal for summer travel and long-distance journeys."
    },
    {
      name: "Mini Bus for Wedding Pune",
      description:
        "Convenient transportation for wedding guests and family members with punctual service and comfortable group seating."
    },
    {
      name: "Corporate Mini Bus Hire Pune",
      description:
        "Professional mini bus service for corporate staff transport, conferences, and business events."
    },
    {
      name: "Mini Bus for Outstation Pune",
      description:
        "Reliable mini bus service for outstation tours and long-distance travel with safe highway performance."
    }
  ],

  tableData: [
    ["Mini Bus On Rent in Pune", "18 Seater Mini Bus Pune"],
    ["20 Seater Mini Bus Pune", "25 Seater Mini Bus Pune"],
    ["AC Mini Bus Rental Pune", "Luxury Mini Bus Pune"],
    ["Mini Bus for Outstation Pune", "Mini Bus for Wedding Pune"],
    ["Corporate Mini Bus Hire Pune", "School Trip Mini Bus Pune"],
    ["Picnic Mini Bus Pune", "Group Travel Mini Bus Pune"],
    ["Mini Bus Per Km Rate Pune", "Affordable Mini Bus Pune"],
    ["Driver Included Mini Bus Pune", "Online Mini Bus Booking Pune"]
  ],

  whychoose: [
    { WhyChooseheading: "Spacious Group Seating", WhyChoosedescription: "Comfortable seating for 18–25 passengers with ample legroom and luggage space." },
    { WhyChooseheading: "Professional Drivers", WhyChoosedescription: "Experienced and background-verified drivers ensure safe and smooth travel." },
    { WhyChooseheading: "Transparent Pricing", WhyChoosedescription: "Clear per-kilometer fare structure with no hidden charges." },
    { WhyChooseheading: "AC Comfort", WhyChoosedescription: "Fully air-conditioned vehicles for comfortable long-distance travel." },
    { WhyChooseheading: "Ideal for Corporate & School Trips", WhyChoosedescription: "Reliable group transport solution for educational and business travel." },
    { WhyChooseheading: "Flexible Packages", WhyChoosedescription: "One-way, round-trip, and multi-day booking options available." },
    { WhyChooseheading: "Well-Maintained Fleet", WhyChoosedescription: "Regularly serviced and sanitized vehicles." },
    { WhyChooseheading: "24/7 Customer Support", WhyChoosedescription: "Round-the-clock booking assistance available." }
  ]
};

const faqData = [
  { question: "What seating options are available?", answer: "18, 20, and 25 seater mini buses available." },
  { question: "Is driver included?", answer: "Yes, professional chauffeur included." },
  { question: "Is AC available?", answer: "Yes, fully air-conditioned mini buses available." },
  { question: "Is outstation booking allowed?", answer: "Yes, available for long-distance tours." },
  { question: "Is pricing per km transparent?", answer: "Yes, clear and upfront fare structure." },
  { question: "Is school trip booking available?", answer: "Yes, ideal for school excursions." },
  { question: "Is corporate hire possible?", answer: "Yes, corporate transport services available." },
  { question: "Is online booking available?", answer: "Yes, instant booking support provided." },
  { question: "Are vehicles sanitized?", answer: "Yes, regularly cleaned and maintained." },
  { question: "Is 24/7 support available?", answer: "Yes, customer support available anytime." }
];

const testimonials = [
  {
    id: 1,
    name: "School Coordinator",
    feedback:
      "Booked 25 seater mini bus for school picnic. Vehicle was clean, driver was disciplined, and travel was safe. Highly recommended for school trips.",
    rating: 5
  },
  {
    id: 2,
    name: "Corporate Client",
    feedback:
      "Used mini bus for company outing. Excellent coordination and punctual service. Comfortable ride for entire team.",
    rating: 5
  },
  {
    id: 3,
    name: "Family Group",
    feedback:
      "Hired mini bus for wedding function. Spacious seating and smooth travel. Very professional service.",
    rating: 5
  }
];












































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus On Rent in Pune",
  "image": "https://lotuscab.com/assets/images/mini-bus-rent-pune.jpg", 
  "description": "Lotus Cab provides mini buses on rent in Pune with 18, 20, and 25 seater options. Perfect for outstation trips, weddings, corporate events, school trips, picnics, and group travel. Choose AC and luxury variants with driver included, affordable per km rates, and convenient online booking for safe and comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4600"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/mini-bus-on-rent-pune"
  }
};










  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Mini Bus On Rent in Pune | Lotus Cab</title>
  <meta 
    name="description" 
    content="Rent mini buses in Pune with Lotus Cab. 18, 20 & 25 seater AC & luxury mini buses for outstation trips, weddings, corporate events, school trips & group travel. Driver included. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Mini Bus On Rent in Pune, 18 Seater Mini Bus Pune, 20 Seater Mini Bus Pune, 25 Seater Mini Bus Pune, AC Mini Bus Rental Pune, Luxury Mini Bus Pune, Mini Bus for Outstation Pune, Mini Bus for Wedding Pune, Corporate Mini Bus Hire Pune, School Trip Mini Bus Pune, Picnic Mini Bus Pune, Group Travel Mini Bus Pune, Mini Bus Per Km Rate Pune, Affordable Mini Bus Pune, Driver Included Mini Bus Pune, Online Mini Bus Booking Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/42.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusonrentinpune;